import { isEmpty } from 'lodash'
import { LotMatchingInstruction } from '../Types'

export const assembleLotMatchingInstructions = (
  lotMatchingInstructions?: LotMatchingInstruction[] | undefined
): { lotMatchingInstructions: LotMatchingInstruction[] } | undefined => {
  const lotMatchingInstructionValues = lotMatchingInstructions
    ?.filter(({ tradeDate }: LotMatchingInstruction) => tradeDate)
    .map(({ tradeDate, quantity, price }: LotMatchingInstruction) => {
      // @ts-ignore
      const tradeDateParts = tradeDate.split('/')
      const tradeDateYYMMDD = `${tradeDateParts[2]}-${tradeDateParts[0]}-${tradeDateParts[1]}`
      return {
        tradeDate: tradeDateYYMMDD,
        quantity,
        price,
      }
    })
  // @ts-ignore
  return isEmpty(lotMatchingInstructionValues)
    ? undefined
    : {
        lotMatchingInstructions: lotMatchingInstructionValues,
      }
}
